import { api, handleResponse, handleError } from "./apiServices";

export const getTermsAndConditions = token =>
  api(token)
    .get("/api/T&C/terms&condition/getAll")
    .then(handleResponse)
    .catch(handleError);

export const addTermsAndConditions = (token, data) =>
  api(token)
    .post("/api/T&C/terms&condition/add", data)
    .then(handleResponse)
    .catch(handleError);

export const editTermsAndConditions = (token, id, data) =>
  api(token)
    .post(`/api/T&C/terms&condition/edit/${id}`, data)
    .then(handleResponse)
    .catch(handleError);
